module.exports = __webpack_public_path__ + "img/emily.b8481f5c.png";